import script from "./priceList.vue?vue&type=script&setup=true&lang=js"
export * from "./priceList.vue?vue&type=script&setup=true&lang=js"

import "./priceList.vue?vue&type=style&index=0&id=59a740ad&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a740ad"]])

export default __exports__